import { toast } from "react-toastify";
const fundsReducer = (
  initialState = {
    funds: [],
    fund: {},
  },
  action
) => {
  switch (action.type) {
    case "GET_FUNDS":
      return {
        ...initialState,
        funds: action.funds.data,
      };
    case "GET_FUND":
      return {
        ...initialState,
        fund: action.fund.data,
      };
    case "CREATE_FUND":
      return {
        ...initialState,
        funds: [action.fund.data, ...initialState.funds],
      };
    case "UPDATE_FUND":
      toast.success("Fund info  updated", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
      });
      return {
        ...initialState,
        fund: action.fund.data,
      };
    case "DELETE_FUND":
      toast.success("Fund deleted", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
      });
      return {
        ...initialState,
        funds: initialState.funds.filter((fund) => fund.id !== action.id),
      };
    default:
      return initialState;
  }
};

export default fundsReducer;
